import React from 'react'
import TextField from '../../TextField'
import { ButtonOutline } from '../../../../Components/GeneralComponents/ButtonOutline/ButtonOutline'
import CheckboxButton from '../../../../Components/GeneralComponents/CheckboxButton'
import PropTypes from 'prop-types'
import classes from './index.module.css'
import FeelsSyncButton from '../../../../Components/FeelsSync/FeelsSyncButton'
import DisabledOverlay from '../../../../Components/GeneralComponents/DisabledOverlay/DisabledOverlay'
import useAdminAccess from '../../../../services/hooks/useAdminAccess'

export default function OffsetActions({
  onVideoOffsetValueChange,
  currentlySelectedLine,
  onLoopLinesClick,
  isLoopingLines,
  tease,
  handleSetCurrentVideoPlayerToLineAction,
  feelsSyncStatus,
  onSyncStatusChange,
  onSyncComplete,
  isTimingLocked,
}) {
  const { hasFullAdminAccess } = useAdminAccess()

  return (
    <div className={classes.wrapper}>
      <div className={classes.input} style={{ position: 'relative' }}>
        <DisabledOverlay show={feelsSyncStatus === 'pending'} />
        <TextField
          name={'lyrics_adj'}
          placeholder={'Enter Seconds to adjust video...'}
          onChange={onVideoOffsetValueChange}
          value={tease.lyrics_adj || 0}
          variant={'rounded'}
          disabled={isTimingLocked}
        />
        <label htmlFor="lyrics_adj" className={classes.input__label}>
          Video Offset (in ms)
        </label>
      </div>
      <div className={classes.actions}>
        <div style={{ position: 'relative' }}>
          <DisabledOverlay show={feelsSyncStatus === 'pending'} />
          <ButtonOutline
            color={'pink'}
            size="extraSmall"
            text={
              currentlySelectedLine !== null
                ? 'ADJUST ALL LINES AHEAD WITH PLAYER TIME'
                : 'SET PLAYER TIME AS VIDEO OFFSET'
            }
            onClick={handleSetCurrentVideoPlayerToLineAction}
            disable={isTimingLocked}
          />
        </div>

        <div style={{ position: 'relative' }}>
          <DisabledOverlay show={feelsSyncStatus === 'pending'} />
          <CheckboxButton
            onClick={onLoopLinesClick}
            condition={isLoopingLines}
            label={'Loop Lines'}
            disabled={feelsSyncStatus === 'pending'}
          />
        </div>

        {hasFullAdminAccess && (
          <FeelsSyncButton 
            song={tease}
            onSyncStatusChange={onSyncStatusChange}
            onSyncComplete={onSyncComplete}
          />
        )}
      </div>
    </div>
  )
}

OffsetActions.propTypes = {
  onVideoOffsetValueChange: PropTypes.func,
  handleSetCurrentVideoPlayerToLineAction: PropTypes.func,
  onLoopLinesClick: PropTypes.func,
  currentlySelectedLine: PropTypes.object,
  isLoopingLines: PropTypes.bool,
  tease: PropTypes.object,
  feelsSyncStatus: PropTypes.string,
  onSyncStatusChange: PropTypes.func,
  onSyncComplete: PropTypes.func,
  isTimingLocked: PropTypes.bool,
}
